<template>
    <div style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: #210F0380;">
        <div class="modal">
            <div @click="confirmClose" style="font-weight: 700; color: #808080;">닫기</div>
            <div v-if="step === 1">
                <div class="main_title">입력 완료하면<br>꿈이 더 가까워집니다</div>
                <div style="display: flex; flex-direction: column; gap: 20px; margin-top: 9px;">
                    <div @click="setCurTab(TAB_TYPE.ELITE)" :style="{scale : setScale(TAB_TYPE.ELITE)}" class="select_box select_box1">
                        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                            <img style="width: 88px;" :src="require('@/assets/img/elite.png')" alt="">
                        </div>
                        <div class="title1">엘리트 선수 출신 회원</div>
                        <div class="contents">실제 선수로 활동한 경력이 있거나,<br>선수 등록 이력이 있으신가요?</div>
                    </div>
                    <div @click="setCurTab(TAB_TYPE.NO_ELITE)" :style="{scale : setScale(TAB_TYPE.NO_ELITE)}" class="select_box select_box2">
                        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                            <img style="width: 166px;" :src="require('@/assets/img/no_elite.png')" alt="">
                        </div>
                        <div class="title2">선수 경험이 없는 회원</div>
                        <div class="contents">아직 정식 선수는 아니지만,<br>축구 선수의 꿈을 이루고 싶으신가요?</div>
                    </div>
                </div>
            </div>
            <div v-else-if="step === 2">
                <div class="main_title">거의 다 왔어요!🙏<br>3번만 더 눌러주세요</div>
                <div style="display: flex; gap: 18px; margin-top: 8px;">
                    <div @click="setCurTabPlayer(TAB_TYPE_PLAYER.CUR_ELITE)" :style="{scale : setScalePlayer(TAB_TYPE_PLAYER.CUR_ELITE)}" style="background: linear-gradient(89.76deg, rgba(255, 113, 113, 0.4) 0.21%, rgba(254, 172, 172, 0.4) 99.79%); color: #DC796A;" class="select_box_player select_box select_box1">
                        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                            <img style="width: 100%;" :src="require('@/assets/img/player_icon.png')" alt="">
                        </div>
                        <div>(전) 엘리트 선수</div>
                    </div>
                    <div @click="setCurTabPlayer(TAB_TYPE_PLAYER.PAST_ELITE)" :style="{scale : setScalePlayer(TAB_TYPE_PLAYER.PAST_ELITE)}" style="background: linear-gradient(89.76deg, rgba(150, 219, 247, 0.4) 0.21%, rgba(109, 159, 219, 0.4) 99.79%); color: #6D9FDB;" class="select_box_player select_box select_box2">
                        <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                            <img style="width: 100%;" :src="require('@/assets/img/player_icon.png')" alt="">
                        </div>
                        <div>(현) 엘리트 선수</div>
                    </div>
                </div>
                <div style="margin-top: 15px;">
                    <div style="font-weight: 500; font-size: 14px; line-height: 16px;">엘리트 선수 활동 시기
                        <span style="color: #a3a3a3;">(중복 선택 가능)</span>
                    </div>
                    <div style="margin-top: 7px; display: flex; gap: 6px;">
                        <div @click="setActivePeriod(each.name)" :style="{backgroundColor: selectActivePeriod.includes(each.name) ? 'var(--color-main)' : ''}" class="common_btn" v-for="each, i in activePeriod" :key="i + 'period'">{{ each.name }}</div>
                    </div>
                </div>
                <div style="margin-top: 15px; margin-bottom: 40px;">
                    <div style="font-weight: 500; font-size: 14px; line-height: 16px;">엘리트 선수 활동 기간</div>
                    <div style="margin-top: 7px; display: flex; gap: 6px;">
                        <div @click="setActiveTerm(each.name)" :style="{backgroundColor: selectActiveTerm === each.name ? 'var(--color-main)' : ''}" class="common_btn" v-for="each, i in activeTerm" :key="i + 'term'">{{ each.name }}</div>
                    </div>
                </div>
            </div>
            <div v-if="step === 1" style="margin-top: 14px; margin-bottom: 4px;">
                <div @click="decision" class="select_btn">선택</div>
            </div>
            <div v-else-if="step === 2" style="margin-top: 14px; margin-bottom: 4px;">
                <div @click="submit" class="select_btn">선택</div>
            </div>
        </div>
        <Transition name="fade">
            <div v-if="isShowOutPopup" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; background: #210F0380;">
                <div class="modal">
                    <div style="font-weight: 700; font-size: 25px; line-height: 32px; text-align: center;">거의 다 왔어요!</div>
                    <div style="text-align: center; font-weight: 500; color: #606060; margin-top: 8px; font-size: 14px; line-height: 24px;">지금 나가면 감독님들이 내 정보를 확인할 수 없어요</div>
                    <div style="display: flex; gap: 30px; margin-top: 14px;">
                        <div @click="closeOutPopup" class="close_popup_btn cancel">취소</div>
                        <div @click="closePopup" class="close_popup_btn out">나가기</div>
                    </div>
                </div>
            </div>
        </Transition>
        <Transition name="fade">
            <div v-if="isShowCompletePopup" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; background: #210F0380;">
                <div class="modal">
                    <div style="font-weight: 700; font-size: 25px; line-height: 32px; text-align: center;">축하해요 🎉</div>
                    <div style="text-align: center; font-weight: 500; color: #606060; margin-top: 8px; line-height: 24px;">회원정보가 업데이트되었어요</div>
                    <div style="display: flex; gap: 30px; margin-top: 14px; justify-content: center;">
                        <div @click="$GlobalStore.setIsShowMemberInfoPopup(false)" style="width: 159px;" class="close_popup_btn out">확인</div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import ResponseCode from '@/ResponseCode'
import moment from 'moment'

const TAB_TYPE = {
    ELITE: '엘리트',
    NO_ELITE: '일반인'
}

const TAB_TYPE_PLAYER = {
    CUR_ELITE: '현) 엘리트 선수',
    PAST_ELITE: '전) 엘리트 선수'
}

export default {
    name: "MemberInfoPopup",
    props: {

    },
    data() {
        return {
            curTab: null,
            curTabPlayer: null,
            TAB_TYPE: TAB_TYPE,
            TAB_TYPE_PLAYER: TAB_TYPE_PLAYER,
            step: 1,
            activePeriod: [
                {name: '초등학교'},
                {name: '중학교'},
                {name: '고등학교'},
            ],
            activeTerm: [
                {name: '1년 미만'},
                {name: '1~2년'},
                {name: '2~5년'},
                {name: '5~9년'},
            ],
            selectActivePeriod: [],
            selectActiveTerm: null,
            isShowOutPopup: false,
            isShowCompletePopup: false
        }
    },
    methods: {
        closePopup() {
            this.$GlobalStore.setIsShowMemberInfoPopup(false)
            const now = moment().format();
            localStorage.setItem('lastConfirmCloseTime', now);
        },
        confirmClose() {
            this.isShowOutPopup = true
        },
        closeOutPopup() {
            this.isShowOutPopup = false
        },
        setActivePeriod(name) {
            if (this.selectActivePeriod.includes(name)) {
                this.selectActivePeriod = this.selectActivePeriod.filter(item => item !== name)
            } else {
                this.selectActivePeriod.push(name)
            }
        },
        setActiveTerm(name) {
            this.selectActiveTerm = name
        },
        async setElitePopup(isElite = false) {
            const formData = new FormData()
            
            formData.append('is_elite', isElite)
            if (isElite) {
                formData.append('visit_reason', this.curTabPlayer)
                formData.append('elite_age', this.selectActivePeriod)
                formData.append('elite_active_period', this.selectActiveTerm)
            }
            
            const res = await this.$Axios.post('/api/member/elite_popup/save', formData)

            if (res.data.code === ResponseCode.SUCCESS && !isElite) {
                this.$GlobalStore.setIsShowMemberInfoPopup(false)
                this.$GlobalStore.setIsShowRequestPopupForce(true)
            } else if (res.data.code === ResponseCode.SUCCESS && isElite) {
                this.isShowCompletePopup = true
            }
        },
        decision() {
            if (!this.curTab) {
                this.$GlobalStore.showAlert('항목을 선택해주세요')
                return
            }
            if (this.curTab === TAB_TYPE.NO_ELITE) {
                this.setElitePopup()
            } else {
                this.step = 2
            }
        },
        submit() {
            if (!this.curTabPlayer) {
                this.$GlobalStore.showAlert('엘리트 선수를 선택해주세요')
                return
            }

            if (this.selectActivePeriod.length === 0) {
                this.$GlobalStore.showAlert('엘리트 선수 활동 시기를 선택해주세요')
                return
            }

            if (!this.selectActiveTerm) {
                this.$GlobalStore.showAlert('엘리트 선수 활동 기간을 선택해주세요')
                return
            }
            this.setElitePopup(true)
        },
        setCurTab(tab) {
            this.curTab = tab
        },
        setCurTabPlayer(tab) {
            this.curTabPlayer = tab
            console.log(this.curTabPlayer)
        },
        setScale(tab) {
            if (!this.curTab) {
                return '1.0'
            } else if (this.curTab === TAB_TYPE.ELITE && tab === TAB_TYPE.ELITE) {
                return '1.03'
            } else if (this.curTab === TAB_TYPE.NO_ELITE && tab === TAB_TYPE.NO_ELITE) {
                return '1.03'
            } else {
                return '0.97'
            }
        },
        setScalePlayer(tab) {
            if (!this.curTabPlayer) {
                return '1.0'
            } else if (this.curTabPlayer === TAB_TYPE_PLAYER.CUR_ELITE && tab === TAB_TYPE_PLAYER.CUR_ELITE) {
                return '1.04'
            } else if (this.curTabPlayer === TAB_TYPE_PLAYER.PAST_ELITE && tab === TAB_TYPE_PLAYER.PAST_ELITE) {
                return '1.04'
            } else {
                return '0.96'
            }
        }
    }
}
</script>

<style scoped>
.modal {
    width: 320px; 
    background: linear-gradient(180deg, #FFE2CF 0%, #FFFFFF 100%); 
    position: absolute; 
    left: 50%; 
    top: 50%; 
    transform: translate(-50%, -50%);
    border-radius: 22px;
    padding: 20px;
}

.select_box {
    /* box-shadow: 0px 3.66px 3.66px 0px #00000040;  */
    border-radius: 24px; 
    text-align: center; 
    position: relative;
    min-height: 155px;
    transition: 0.2s all;
}

.select_box1 {
    background: linear-gradient(89.76deg, rgba(255, 113, 113, 0.4) 0.21%, rgba(255, 196, 196, 0.4) 99.79%); 
}

.select_box2 {
    background: linear-gradient(89.76deg, rgba(209, 228, 255, 0.4) 0.21%, rgba(67, 152, 255, 0.4) 99.79%); 
}

.select_box_player {
    height: 132px; 
    width: 132px; 
    min-height: 132px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}

.main_title {
    font-weight: 700; 
    font-size: 20px; 
    line-height: 27px; 
    /* color: var(--color-main);  */
    text-align: center; 
    margin-top: 4px;
}

.title1 {
    color: #DC796A; 
    margin-top: 35px; 
    font-weight: 700; 
    font-size: 27px; 
    line-height: 28px;
}

.title2 {
    color: #6D9FDB;
    margin-top: 35px; 
    font-weight: 700; 
    font-size: 27px; 
    line-height: 28px;
}

.contents {
    margin-top: 20px; 
    font-weight: 500; 
    color: #606060C2; 
    line-height: 20px; 
    margin-bottom: 28px;
}

.select_btn {
    height: 39px; 
    line-height: 39px; 
    text-align: center; 
    border: 1px solid #797979; 
    border-radius: 20px; 
    font-weight: 700; 
    font-size: 12px;
    color: #797979;
}

.common_btn {
    border-radius: 10px;
    background-color: #fff;
    width: 80px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    font-weight: 500
}

.close_popup_btn {
    width: 120px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
}

.cancel {
    background-color: #efefef;
    box-shadow: 2px 2px 10px 0px #0000001A;
    border: 1px solid #0000001A
}

.out {
    background-color: var(--color-main);
    color: #fff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>